import t from 'tcomb';
import UUID from './UUID';
import Purchase_State from './Purchase_State';
import Datetime from './Datetime';
import Currency from './Currency';
import Amount from './Amount';
import Domicile from './Domicile';
import Coupon from './Coupon';
import Invoice from './Invoice';
import Purchase_Payment from './Purchase_Payment';
import Custom_Payment  from './Custom_Payment';

const Purchase = t.struct({
  id: UUID,
  productId: t.maybe(UUID),
  status: Purchase_State,
  tick: Datetime,
  product: t.Str,
  currency: Currency,
  amount: Amount,
  domicile: t.maybe(Domicile),
  coupon: t.maybe(Coupon),
  invoice: t.maybe(Invoice),
  payment: t.maybe(Purchase_Payment),
  discount: Amount,
  image: t.Str,
  custom_payments: t.maybe(t.list(Custom_Payment)),
  pending_purchase_message: t.maybe(t.Str),
  gift_card_not_supported: t.maybe(t.Bool),
  gift_card_code: t.maybe(t.Str),
  payment_amount: t.maybe(Amount)
}, 'Purchase');

module.exports = Purchase;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Purchase.js
 **/